import React from 'react'
import classNames from 'classnames'
import Button from '@material-ui/core/Button';
// import { withStyles } from '@material-ui/core/styles'
// import { Link } from 'gatsby' USE WITH V2
import Link from 'gatsby-link'

import css from './header.module.css'
// import linkCss from './link.module.css'
import SimpleMenu from './menu'
// import TextButton from './button'
import withRoot from '../withRoot'

import logo225 from "../images/logo225a.png"

import 'typeface-roboto'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});

const Header = ({ siteTitle }) => (
  
  <div
    style={{
      
      // background: 'rgba(0 0 0 .08)',
      background: 'none',
      // position: 'absolute',
      // top: 0,
      // width: '100%'
    }}
  >
    <div className={classNames(css.split_container)}>
      

      <div className={classNames(css.right_container)} >
        <div className={css.grid_item} style={{msGridColumn: 1}}></div>
        <div className={classNames(css.grid_item)} style={{msGridColumn: 2}}><SimpleMenu /></div>
        <div className={classNames(css.grid_item, css.align_right)} style={{msGridColumn: 3}}>
          <Button component={Link} to="/about">
            About
          </Button>
        </div >
        <div className={classNames(css.grid_item, css.align_right)} style={{msGridColumn: 4}}>
          <Button component={Link} to="/contact">
            Contact
          </Button>
        </div>
        <div className={css.grid_item} style={{msGridColumn: 5}}></div>
      </div> 

      <div className={classNames(css.left_container)} >
        <div className={css.grid_item} style={{msGridColumn: 1}} ></div>

        <div className={classNames(css.grid_item)} style={{msGridColumn: 2}}>
          <Button component={Link} to="/">
            <img src={logo225} alt="Logo" 
            
            className={css.logo} style={{
              
            WebkitFilter: 'drop-shadow(3px 3px 2px rgba(0,0,0,0.5))',
            filter: 'url(#drop-shadow)',
            MsFilter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=3, OffY=3, Color='#444')",
            filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=3, OffY=3, Color='#444')",
            }}/>
          </Button>
        </div>

        <div className={css.grid_item} style={{msGridColumn: 3}}></div>
      </div>
    


      

    </div>
      

    
  </div>
)

// export default withRoot(Header)
export default withRoot(Header);



// WEBPACK FOOTER //
// ./src/components/header.js